import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import EditConfiguration from "../views/EditConfiguration.vue";
import EditShip from "../views/EditShip.vue";
import EconomicView from "../views/EconomicView.vue";
import LoggingView from "../views/LoggingView.vue";
import CarbonView from "../views/CarbonView.vue";
import NeobuqHomeView from "../views/NeobuqHomeView.vue"
import NeobuqCarbonView from "../views/NeobuqCarbonView.vue"
import FuelEUView from "../views/FuelEUView.vue"
import ETSView from "../views/ETSView.vue"
import NeobuqEditShip from "../views/NeobuqEditShip.vue"
import EditModification from "../views/NeobuqEditModificationView.vue"
import NeobuqEconomicView from "../views/NeobuqEconomicView"
import EcoefficiencyView from "../views/EcoefficiencyView"
import ReportView from "../views/NeobuqReportView.vue"

const routes = [
  {
    path: "/home",
    name: "home",
    component: HomeView,
  },
  {
    path: "/editShip/:id",
    name: "editShip",
    component: EditShip,
    props: true,
  },
  {
    path: "/editConfiguration/:id",
    name: "editConfiguration",
    component: EditConfiguration,
    props: true,
  },
  {
    path: "/",
    name: "logging",
    component: LoggingView,
  },
  {
    path: "/edit_economic/:id",
    name: "editEconomic",
    component: EconomicView,
    props: true,
  },
  {
    path: "/carbonView/:id",
    name: "CarbonView",
    component: CarbonView,
    props: true,
  },
  {
    path: "/neobuq/home", 
    name: "neobuqHome",
    component: NeobuqHomeView,
    props: true,
  },
  {
    path: "/neobuq/carbon/:id", 
    name: "neobuqCarbon",
    component: NeobuqCarbonView,
    props: true,
  },
  {
    path: "/neobuq/fuelEU/:id", 
    name: "fuelEU",
    component: FuelEUView,
    props: true,
  },
  {
    path: "/neobuq/ETS/:id", 
    name: "ETS",
    component: ETSView,
    props: true,
  },
  {
    path: "/neobuq/editShip/:id", 
    name: "neobuqEditShip",
    component: NeobuqEditShip,
    props: true,
  },
  {
    path: "/neobuq/editModification/:id",
    name: "editModification",
    component: EditModification,
    props: true,
  },
  {
    path: "/neobuq/economicPart/:id",
    name: "neobuqEconomicPart",
    component: NeobuqEconomicView,
    props: true,
  },
  {
    path: "/neobuq/ecoefficiencyPart/:id",
    name: "neobuqEcoefficiencyPart",
    component: EcoefficiencyView,
    props: true,
  },
  {
    path: "/neobuq/report",
    name: "reportForm",
    component: ReportView,
    props: (route) => ({ shipsChecked: route.params.shipsChecked })
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
